import React, { useContext, useEffect, useMemo, useState } from "react";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import SelectionItem from "../../SelectionItem";
import "./index.scss";
import slidesVRContent from "../../../mediaContent/slidesVRContent";
import { useMediaQuery } from "@mui/material";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const OrthodonticAnomalies = () => {
  const {
    language
  } = useTranslation();
  const {
    openVRSlider
  } = useContext(StepContext);
  const [pageTotal, setPageTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [types, setTypes] = useState([]);
  const slides = useMemo(() => {
    return slidesVRContent(language);
  }, [language]);
  const isTablet = useMediaQuery("(max-width:1024px)");
  useEffect(() => {
    let size = isTablet ? 4 : 6;
    let subarray = [];
    let page = Math.ceil(slides.length / size);

    for (let i = 0; i < page; i++) {
      subarray[i] = slides.slice(i * size, i * size + size);
    }

    setContainerWidth(size / 2 * 240);
    setPageTotal(page);
    setTypes(subarray);
  }, [isTablet, slides]);

  function openSlider(key) {
    let slide = slides.find(el => el.key === key);
    openVRSlider(true, slide.name, key, slide.totalSlides);
  }

  function moveBack() {
    if (page > 0) {
      setPage(prev => prev - 1);
    }
  }

  function moveForward() {
    if (page < pageTotal - 1) {
      setPage(prev => prev + 1);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "orthodonticAnomalies"
  }, /*#__PURE__*/React.createElement("div", {
    className: "orthodonticAnomalies-container",
    style: {
      maxWidth: containerWidth
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "orthodonticAnomalies-container-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "orthodonticAnomalies-container-wrapper-slide",
    style: {
      transform: `translateX(calc((-100% / ${pageTotal}) * ${page}))`
    }
  }, types.map((part, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "orthodonticAnomalies-container-wrapper-slide-part"
  }, part.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    isSelected: false,
    select: () => {
      openSlider(el.key);
    },
    preview: el.preview,
    outerTitle: el.name
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "orthodonticAnomalies-container-slide-controls back",
    onClick: moveBack
  }, /*#__PURE__*/React.createElement(ArrowBackIos, null)), /*#__PURE__*/React.createElement("div", {
    className: "orthodonticAnomalies-container-slide-controls forward",
    onClick: moveForward
  }, /*#__PURE__*/React.createElement(ArrowForwardIos, null))));
};

export default OrthodonticAnomalies;